module.exports = __webpack_public_path__ + "static/media/fly0140.db2da448.webp";